import React from "react";

const BackgroundEmojis = () => {
  // Hard work and productivity emojis - cute and motivational
  const emojis = [
    "💪", "🔥", "⚡", "🚀", "⭐", "🎯", "🏆", "💎", 
    "✨", "🌟", "💼", "📈", "🎓", "💡", "🔨", "⚙️",
    "👊", "🎖️", "📚", "🛠️", "🎪", "🎨", "🏅", "💯"
  ];

  // Generate random positions for emojis
  const getRandomPosition = () => ({
    top: `${Math.random() * 100}%`,
    left: `${Math.random() * 100}%`,
    fontSize: `${16 + Math.random() * 12}px`,
    opacity: 0.15 + Math.random() * 0.2, // Subtle but visible
    animationDelay: `${Math.random() * 5}s`,
  });

  return (
    <div className="fixed inset-0 pointer-events-none overflow-hidden z-0">
      {emojis.map((emoji, index) => (
        <span
          key={index}
          className="absolute animate-float"
          style={{
            ...getRandomPosition(),
            animationDuration: `${3 + Math.random() * 4}s`,
          }}
        >
          {emoji}
        </span>
      ))}
    </div>
  );
};

export default BackgroundEmojis;

